<template>
    <div class="cgs-app-edit" :class="theme">
        <div class="cgs-editApp-header">
            <van-nav-bar :border="false">
                <template #left>
                    <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
                </template>
                <template #right>
                    <span class="iconfont cgsIcon-queren" style="font-size: 20px" @click="save"></span>
                </template>
            </van-nav-bar>
        </div>
        <div class="cgs-editApp-content">
            <div class="editApp-item-container">
                <div class="editApp-item-title">名称</div>
                <van-field v-model="name" />
            </div>
            <van-divider />
            <change-theme-icon :theme="theme" :icon="icon" @changeTheme="selectTheme" @changeIcon="selectIcon"></change-theme-icon>
        </div>
    </div>
</template>

<script>
import { NavBar, Divider, Field, Swipe, SwipeItem } from 'vant';
import { getAppList, updateApp } from '@/api/application';
import changeThemeIcon from "../baseComponents/changeThemeIcon.vue"
import { defaultIcon_app } from "@/util/LOGO_ICON_CONFIG"

export default {
    components:{
        vanNavBar: NavBar,
        vanDivider: Divider,
        vanField: Field,
        vanSwipe: Swipe,
        vanSwipeItem: SwipeItem,
        changeThemeIcon
    },
    data(){
        return {
            name: '',
            theme: 'defaultTheme',
            icon: defaultIcon_app
        }
    },
    computed: {
        appId:{
            get(){
                return this.$route.params.appId;
            },
            set(){}
        },
    },
    mounted(){
        this.init()
    },
    methods:{
        async init(){
            // this.wholeLoading = true
            try{
                let result = await getAppList(this.appId);
                let appDetail = result.data;
                this.name = appDetail.title;
                this.icon = appDetail.icon?appDetail.icon:defaultIcon_app;
                this.theme = appDetail.theme?appDetail.theme:'defaultTheme';
            } catch(e){
                console.error(e)
            } finally{
                // this.wholeLoading = false
            }
        },
        async save(){
            let result = await updateApp({
                "id": this.appId,
                "icon": this.icon,
                "title": this.name,
                "theme": this.theme
            })
            if(result){
                this.$Notify({ type: 'success', message: '更新成功' })
                this.$router.go(-1)
            } else {
                this.$Notify({ type: 'danger', message: '更新失败' })
            }
        },
        goBack(){
            this.$router.go(-1)
        },
        selectTheme(themeItem){
            this.theme = themeItem.className
        },
        selectIcon(iconItem){
            this.icon = iconItem.iconName
        }
    }
    
}
</script>

<style scoped>
.editApp-item-container{
    padding: 15px 15px 0px 15px;
}
.editApp-item-title{
    font-size: 14px;
    color: rgba(0,0,0,0.3);
    padding-bottom: 15px;
}
</style>
<style>
.cgs-editApp-content .van-cell.van-field{
    padding: unset;
    /* padding-top: 15px; */
}
</style>

<style lang="less">
@import "../../assets/style/less/application.less";
    .theme1{
        .applicationTheme(rgba(255, 185, 0,1), rgba(255, 185, 0,0.2))
    }
    .theme2{
        .applicationTheme(rgba(255, 140, 0,1), rgba(255, 140, 0,0.2))
    }
    .theme3{
        .applicationTheme(rgba(247, 99, 12,1), rgba(247, 99, 12,0.2))
    }
    .theme4{
        .applicationTheme(rgba(202, 80, 16,1), rgba(202, 80, 16,0.2))
    }
    .theme5{
        .applicationTheme(rgba(218, 59, 1,1), rgba(218, 59, 1,0.2))
    }
    .theme6{
        .applicationTheme(rgba(239, 105, 80,1), rgba(239, 105, 80,0.2))
    }
    .theme7{
        .applicationTheme(rgba(209, 52, 56,1), rgba(209, 52, 56,0.2))
    }
    .theme8{
        .applicationTheme(rgba(255, 67, 67,1), rgba(255, 67, 67,0.2))
    }

    .theme9{
        .applicationTheme(rgba(231, 72, 86, 1), rgba(231, 72, 86, 0.2))
    }
    .theme10{
        .applicationTheme(rgba(232, 17, 35, 1), rgba(232, 17, 35, 0.2))
    }
    .theme11{
        .applicationTheme(rgba(234, 0, 94, 1), rgba(234, 0, 94, 0.2))
    }
    .theme12{
        .applicationTheme(rgba(195, 0, 82, 1), rgba(195, 0, 82, 0.2))
    }
    .theme13{
        .applicationTheme(rgba(227, 0, 140, 1), rgba(227, 0, 140, 0.2))
    }
    .theme14{
        .applicationTheme(rgba(191, 0, 119, 1), rgba(191, 0, 119, 0.2))
    }
    .theme15{
        .applicationTheme(rgba(194, 57, 179, 1), rgba(194, 57, 179, 0.2))
    }
    .theme16{
        .applicationTheme(rgba(154, 0, 137, 1), rgba(154, 0, 137, 0.2))
    }



    .theme17{
        .applicationTheme(rgba(0, 120, 215, 1), rgba(0, 120, 215, 0.2))
    }
    .theme18{
        .applicationTheme(rgba(0, 99, 177, 1), rgba(0, 99, 177, 0.2))
    }
    .theme19{
        .applicationTheme(rgba(142, 140, 216, 1), rgba(142, 140, 216, 0.2))
    }
    .theme20{
        .applicationTheme(rgba(107, 105, 214, 1), rgba(107, 105, 214, 0.2))
    }
    .theme21{
        .applicationTheme(rgba(135, 100, 184, 1), rgba(135, 100, 184, 0.2))
    }
    .theme22{
        .applicationTheme(rgba(116, 77, 169, 1), rgba(116, 77, 169, 0.2))
    }
    .theme23{
        .applicationTheme(rgba(177, 70, 194, 1), rgba(177, 70, 194, 0.2))
    }
    .theme24{
        .applicationTheme(rgba(136, 23, 152, 1), rgba(136, 23, 152, 0.2))
    }

    .defaultTheme{
        .applicationTheme(rgba(0, 153, 188, 1), rgba(0, 153, 188, 0.2))
    }
    .theme26{
        .applicationTheme(rgba(45, 125, 154, 1), rgba(45, 125, 154, 0.2))
    }
    .theme27{
        .applicationTheme(rgba(0, 183, 195, 1), rgba(0, 183, 195, 0.2))
    }
    .theme28{
        .applicationTheme(rgba(3, 131, 135, 1), rgba(3, 131, 135, 0.2))
    }
    .theme29{
        .applicationTheme(rgba(0, 178, 148, 1), rgba(0, 178, 148, 0.2))
    }
    .theme30{
        .applicationTheme(rgba(1, 133, 116, 1), rgba(1, 133, 116, 0.2))
    }
    .theme31{
        .applicationTheme(rgba(0, 204, 106, 1), rgba(0, 204, 106, 0.2))
    }
    .theme32{
        .applicationTheme(rgba(16, 137, 62, 1), rgba(16, 137, 62, 0.2))
    }

    .theme33{
        .applicationTheme(rgba(122, 117, 116, 1), rgba(122, 117, 116, 0.2))
    }
    .theme34{
        .applicationTheme(rgba(93, 90, 88, 1), rgba(93, 90, 88, 0.2))
    }
    .theme35{
        .applicationTheme(rgba(104, 118, 138, 1), rgba(104, 118, 138, 0.2))
    }
    .theme36{
        .applicationTheme(rgba(81, 92, 107, 1), rgba(81, 92, 107, 0.2))
    }
    .theme37{
        .applicationTheme(rgba(86, 124, 115, 1), rgba(86, 124, 115, 0.2))
    }
    .theme38{
        .applicationTheme(rgba(72, 104, 96, 1), rgba(72, 104, 96, 0.2))
    }
    .theme39{
        .applicationTheme(rgba(73, 130, 5, 1), rgba(73, 130, 5, 0.2))
    }
    .theme40{
        .applicationTheme(rgba(16, 124, 16, 1), rgba(16, 124, 16, 0.2))
    }

    .theme41{
        .applicationTheme(rgba(118, 118, 118, 1), rgba(118, 118, 118, 0.2))
    }
    .theme42{
        .applicationTheme(rgba(76, 74, 72, 1), rgba(76, 74, 72, 0.2))
    }
    .theme43{
        .applicationTheme(rgba(105, 121, 126, 1), rgba(105, 121, 126, 0.2))
    }
    .theme44{
        .applicationTheme(rgba(74, 84, 89, 1), rgba(74, 84, 89, 0.2))
    }
    .theme45{
        .applicationTheme(rgba(100, 124, 100, 1), rgba(100, 124, 100, 0.2))
    }
    .theme46{
        .applicationTheme(rgba(82, 94, 84, 1), rgba(82, 94, 84, 0.2))
    }
    .theme47{
        .applicationTheme(rgba(132, 117, 69, 1), rgba(132, 117, 69, 0.2))
    }
    .theme48{
        .applicationTheme(rgba(126, 115, 95, 1), rgba(126, 115, 95, 0.2))
    }
</style>